export default class FormWaitMessage {
  constructor(element) {
    this.form = element
    this.submitButton = this.form.querySelector('.btn-toolbar *[type=submit]')

    this.init()
  }

  init() {
    this.form.addEventListener('submit', (e) => this.handleMessage(e))
  }

  handleMessage(e) {
    // Disable button after submit and add message
    if (this.submitButton) {
      this.submitButton.disabled = true

      this.submitButton.value = 'Bezig met verzenden.  '
      this.submitButton.classList.add('is-submitting')

      // Dots animation:
      const dotsanimation = setInterval(function () {
        const button = document.querySelector('.btn-toolbar *[type=submit].is-submitting')
        if (button) {
          let buttontext = button.value

          if (buttontext.endsWith('.  ')) {
            button.value = buttontext.slice(0, -3) + ' . '
          } else if (buttontext.endsWith(' . ')) {
            button.value = buttontext.slice(0, -3) + '  .'
          } else {
            button.value = buttontext.slice(0, -3) + '.  '
          }
        } else {
          clearInterval(dotsanimation)
        }
      }, 300)
    }
  }
}
